<template>
    <section class="certificate">
        <div class="certificate-circle-gradient"></div>
        <div class="certificate-decor"></div>
        <div class="certificate-container">
            <div class="certificate-content">
                <h2>{{ t('index.certificate.title') }}</h2>
                <span>{{ t('index.certificate.paragraph1') }}</span><br>
                <span>{{ t('index.certificate.paragraph2') }}</span>
                <br>
                <UIButton
                  class="mt-[40px]"
                  variant="secondary-arrow"
                  padding="17px 35px"
                  rounded="8px"
                  size="large"
                  :href="`/${currentLocale}#courses-section`"
                  :text="t('index.certificate.chooseCourseButton')"
                  @click="onChooseCourseClick"
                />
                <div class="certificate-gift" aria-hidden="true">
                  <picture>
                    <img src="/assets/images/home-page/gift/x1/podarunok-v-rukakh-kraft-papir-rozheva-strichka.png" srcset="/assets/images/home-page/gift/x1/podarunok-v-rukakh-kraft-papir-rozheva-strichka.png 1x, /assets/images/home-page/gift/x2/podarunok-v-rukakh-kraft-papir-rozheva-strichka.png 2x" alt="Жіночі руки тримають подарункову коробку в крафтовому папері з рожевою стрічкою та бантом" width="592" height="443" loading="lazy" decoding="async">
                  </picture>
                </div>
            </div>
            <div class="certificate-image">
                <picture>
                  <img src="/assets/images/home-page/gift/x1/divchyna-trymaie-podarunok-bila-korobka.png" srcset="/assets/images/home-page/gift/x1/divchyna-trymaie-podarunok-bila-korobka.png 1x, /assets/images/home-page/gift/x2/divchyna-trymaie-podarunok-bila-korobka.png 2x" alt="Усміхнена молода дівчина тримає в руках світлу подарункову коробку, перев'язану рожевою стрічкою" width="400" height="300" loading="lazy" decoding="async">
                </picture>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const route = useRoute()
const router = useRouter()

const currentLocale = computed(() => (route.params.locale ?? locale.value) as string)

function scrollToCoursesSection () {
  nextTick(() => {
    const el = document.getElementById('courses-section')
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
}

function onChooseCourseClick (e: MouseEvent) {
  e.preventDefault()
  const homePath = `/${currentLocale.value}`
  if (route.path === homePath) {
    scrollToCoursesSection()
    router.replace({ path: homePath, hash: '#courses-section' })
  } else {
    router.push({ path: homePath, hash: '#courses-section' })
  }
}
</script>

<style scoped>
.certificate {
    position: relative;
    background: linear-gradient(90deg, #09AFEA 0%, #19E089 100%);
    padding: 0;
    overflow: hidden;
}



.certificate-decor {
    position: absolute;
    inset: 0;
    background: url('../../../../assets/images/certificate-decor.png') no-repeat center center;
    background-size: cover;
    pointer-events: none;
    z-index: 3;
}

.certificate-container {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 90px 50px 98px 50px;
    height: 100%;
    max-width: var(--max-width-container);
    position: relative;
}

.certificate-content {
    max-width: 555px;
}

.certificate-content h2 {
    font-family: var(--font-inter);
    font-weight: 600;
    font-size: 46px;
    line-height: 1.2;
    color: #fff;
    margin-bottom: 24px;
    letter-spacing: 1.4px;
}

.certificate-content span {
    font-family: var(--font-inter);
    font-size: var(--font-size-body);
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 16px;
}

.certificate-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    min-width: 158px;
    height: 50px;
    padding: 0 24px;
    background: #fff;
    color: #252840;
    font-family: var(--font-inter);
    font-weight: 500;
    font-size: var(--font-size-body);
    text-decoration: none;
    border: none;
    border-radius: 5px;
    transition: all 0.2s;
}

.certificate-btn:hover {
    background: #f5f5f5;
}

.certificate-image {
    width: 100%;
    height: 100%;
    pointer-events: none;
    display: flex;
    justify-content: center;
}

.certificate-image picture {
    display: contents;
}

.certificate-image img {
    object-fit: cover;
    width: 1130px;
    display: block;
    position: absolute;
    z-index: 4;
    bottom: -1px;
    /* transform-origin: right bottom; */
    /* transform: scale(1.8); */
}

.certificate-gift {
    display: none;
    justify-content: center;
    margin-top: 35px;
}

.certificate-gift picture {
    display: block;
}

.certificate-gift img {
    width: min(420px, 60vw);
    height: auto;
    display: block;
    margin-bottom: -1px;
}

@media (max-width: 1400px) {
    .certificate-container {
        padding: 90px 60px;
    }
}
@media (max-width: 1150px) {
    .certificate-image img {
        height: 400px;
    }
    .certificate{
        height: 500px;
    }
}

@media (max-width: 991px) {
    .certificate {
        height: auto;
        padding: 40px  0;
    }

    .certificate-container {
        flex-direction: column;
        text-align: center;
        padding: 0 30px;
        height: auto;
    }
    .certificate-image {
        display: none;
    }
}

@media (max-width: 768px) {
    .certificate-gift {
        display: flex;
    }
    .certificate {
        height: auto;
        padding: 40px  0 0 0;
    }
}

@media (max-width: 767px) {
    .certificate-container {
        padding: 0 20px;
    }

    .certificate-content {
        max-width: 100%;
        /* margin-bottom: 20px;  */
    }

    .certificate-content h2 {
        font-size: 24px;
    }

    .certificate-image {
        position: relative;
        /* right: auto; */
        /* bottom: auto; */
    }
    .certificate-decor{
        display: none;
    }
    .certificate {
        background: linear-gradient(90deg, #00C1B6 0%, #00C2D9 100%);
    }

    .certificate-circle-gradient {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background: url('../../../../assets/images/circle-gradient.svg') no-repeat center;
        background-size: contain;
        pointer-events: none;
        z-index: 0;
        top: -165px;
        width: 250px;
        height: 250px;
    }
    .certificate-content h2 {
    text-shadow: none
    }
}
@media (max-width: 480px) {
    .certificate{
        padding: 103px 0 0 0;
    }   
    .certificate-content h2 {
        font-size: 35px;
    }
    .certificate-content span {
        font-size: 21px;
    }
}
</style>
